var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.46,
    height: 43.46,
    viewBox: "0 0 43.46 43.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(20.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M445.19,385.985a21.684,21.684,0,0,0,17.115-8.348H450.86C449.382,382.562,448.558,385.985,445.19,385.985Z",
    transform: "translate(-443.889 -342.525)",
    fill: "#b60c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M442.6,394.265h0Z",
    transform: "translate(-442.587 -350.842)",
    fill: "#b60c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M450.86,315.733h11.445a21.688,21.688,0,0,0-17.115-8.348C448.558,307.385,449.382,310.808,450.86,315.733Z",
    transform: "translate(-443.889 -307.385)",
    fill: "#b60c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M442.587,307.462h0Z",
    transform: "translate(-442.587 -307.423)",
    fill: "#b60c1b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M467.979,324.088H456.534a52.544,52.544,0,0,1,0,26.763h11.444a21.706,21.706,0,0,0,0-26.763Z",
    transform: "translate(-429.134 -315.74)",
    fill: "#ffb400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(20.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M443.9,394.3q-.648,0-1.289-.037C443.044,394.29,443.475,394.3,443.9,394.3Z",
    transform: "translate(-442.611 -350.843)",
    fill: "#b60c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M442.611,307.423q.64-.038,1.289-.038C443.475,307.385,443.044,307.4,442.611,307.423Z",
    transform: "translate(-442.611 -307.385)",
    fill: "#b60c1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(4.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M435.33,377.637H410.948a21.688,21.688,0,0,0,15.813,8.31h.012q.64.037,1.289.037C431.43,385.985,433.853,382.562,435.33,377.637Z",
    transform: "translate(-410.948 -342.525)",
    fill: "#c60624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M410.948,315.733H435.33c-1.477-4.925-3.9-8.348-7.268-8.348q-.649,0-1.289.038h-.012A21.689,21.689,0,0,0,410.948,315.733Z",
    transform: "translate(-410.948 -307.385)",
    fill: "#c60624"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M401.712,337.47a21.624,21.624,0,0,0,4.616,13.381H430.71a52.542,52.542,0,0,0,0-26.763H406.328A21.629,21.629,0,0,0,401.712,337.47Z",
    transform: "translate(-401.712 -315.74)",
    fill: "#ffc521"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.5d177c9cf066d27f5f017a43752e385a.svg";
export { ForwardRef as ReactComponent };